<div class="strength-bar-wrapper">
  <div class="strengthBar row my-0">
    <div class="point-wrapper col-3">
      <div class="point" [style.background-color]="bar0"></div>
    </div>
    <div class="point-wrapper col-3">
      <div class="point" [style.background-color]="bar1"></div>
    </div>
    <div class="point-wrapper col-3">
      <div class="point" [style.background-color]="bar2"></div>
    </div>
    <div class="point-wrapper col-3">
      <div class="point" [style.background-color]="bar3"></div>
    </div>
  </div>
  <div class="mb-3 mt-2 px-2">
    <div
      class="row my-0 px-2 list-row"
      *ngFor="let item of ruleCheckListTexts | keyvalue"
    >
      <div class="col-1 pe-0 ps-3 py-1">
        <mat-icon class="list-icon" [class.green-icon] = "ruleCheckListStates[item.key] === true" [class.red-icon] = "ruleCheckListStates[item.key] === false">{{
          ruleCheckListStates[item.key] ? "check" : "close"
        }}</mat-icon>
      </div>
      <div class="col-11 px-2 py-0">
        <span class="list-text">{{ item.value }}</span>
      </div>
    </div>
  </div>
</div>
